// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5f5c9169","101":"26dc9f97","107":"14de4054","609":"2b96ee1c","793":"4de8b93a"}[chunkId] + ".chunk.js";
};